export const SET_IS_OPEN_WALLET_MODAL = 'SET_IS_OPEN_WALLET_MODAL';
export const SET_USER_ID_WALLET = 'SET_USER_ID_WALLET';
export const SET_USER_ROLES_MULTIPLE_STATE = 'SET_USER_ROLES_MULTIPLE_STATE';

const initState = {
	isOpenWalletModal: false,
	walletUserId: null,
	userData: null
};

export const userRolesReducer = (state = initState, action) => {
	switch (action.type) {
		case SET_IS_OPEN_WALLET_MODAL:
			return {
				...state,
				isOpenWalletModal: action.payload
			};
		case SET_USER_ID_WALLET:
			return {
				...state,
				walletUserId: action.payload
			};
		case SET_USER_ROLES_MULTIPLE_STATE:
			return {
				...state,
				...action.payload,
			}
		default:
			return state;
	}
};

export default userRolesReducer;
